import { parse } from './parse.js'
import { stringify } from './stringify.js'
export { parse, stringify }
export default { parse, stringify }
